"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "concesio": {
    "5b74c190": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ca-de-bosio": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "concesio"
    }],
    "90ae70fb": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "campagnola": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "concesio"
    }],
    "d647d3b8": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "costorio": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "concesio"
    }],
    "704af6ed": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pieve": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "concesio"
    }],
    "c5c98b33": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "roncaglie": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "concesio"
    }],
    "12944058": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "concesio"
    }],
    "54c96e56": [{
      "hkey": "18617a8f",
      "slug": "concesio",
      "name": "Concesio",
      "primary": true,
      "skipSearch": false
    }],
    "stella": [{
      "hkey": "18617a8f",
      "slug": "concesio",
      "name": "Concesio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec634742": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "stocchetta": [{
      "hkey": "16eaa3db",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "concesio"
    }]
  }
};
exports["default"] = _default;